import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=7b8601d4&"
import script from "./Info.vue?vue&type=script&lang=js&"
export * from "./Info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b8601d4')) {
      api.createRecord('7b8601d4', component.options)
    } else {
      api.reload('7b8601d4', component.options)
    }
    module.hot.accept("./Info.vue?vue&type=template&id=7b8601d4&", function () {
      api.rerender('7b8601d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Quotations/Tabs/Info.vue"
export default component.exports